<ng-container>
  <div>
    <ul class="space-y-3" style="flex-grow: 1; list-style: none; padding: 0; margin: 0;">
      <li class="flex items-start text-sm text-slate-700">
        <svg class="h-5 w-5 text-brand shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path></svg>
        Turnkey Monitoring solution
      </li>
      <li class="flex items-start text-sm text-slate-700">
        <svg class="h-5 w-5 text-brand shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path></svg>
        Email summary of monitored flows
      </li>
      <li class="flex items-start text-sm text-slate-700">
        <svg class="h-5 w-5 text-brand shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path></svg>
        Flow runs beyond 30 days
      </li>
    </ul>

    @if (showTiles) {
      <div class="grid grid-cols-3 gap-2 mt-4">
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="desktop" class="text-sm mb-1"></fa-icon>
          Flow Monitoring
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="history" class="text-sm mb-1"></fa-icon>
          <span title="Flow run history beyond 30 days">Run History 30D+</span>
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="server" class="text-sm mb-1"></fa-icon>
          <span title="Enterprise scale - millions of flows">Enterprise Scale</span>
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="envelope-open-text" class="text-sm mb-1"></fa-icon>
          <span title="Summary email notifications">Email Notifications</span>
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="external-link-alt" class="text-sm mb-1"></fa-icon>
          <span title="Webhook API for Power Platform events">Webhook API</span>
        </div>
        <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
          <fa-icon icon="database" class="text-sm mb-1"></fa-icon>
          BYO Data Storage
        </div>
      </div>
    }
  </div>
</ng-container>
